const prefix = 'DimContractItem';

export enum DimContractItemField {
  CURRENCY = `${prefix}.currency`,
  LINE_ITEM_NUMBER = `${prefix}.lineItemNumber`,
  ID = `${prefix}.id`,
  UNIT_ID = `${prefix}.unitId`,
  TITLE = `${prefix}.title`,
  DESCRIPTION = `${prefix}.description`,
  PLANNED_QUANTITY = `${prefix}.plannedQuantity`,
  PLANNED_VALUE = `${prefix}.plannedValue`,
  PLANNED_VALUE_NORMALIZED = `${prefix}.plannedValueNormalized`,
  PRICE_PER_UNIT = `${prefix}.pricePerUnit`,
}
